import { render, staticRenderFns } from "./form_view.vue?vue&type=template&id=24e4c8fc&scoped=true"
import script from "./form_view.vue?vue&type=script&lang=js"
export * from "./form_view.vue?vue&type=script&lang=js"
import style0 from "./form_view.vue?vue&type=style&index=0&id=24e4c8fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e4c8fc",
  null
  
)

export default component.exports